import type { AppError, ErrorKind } from '@/shared/model/types/error';

type Reporter = (error: AppError, context?: Record<string, unknown>) => void;

let reporter: Reporter | null = null;

export const setErrorReporter = (next: Reporter | null): void => {
  reporter = next;
};

const SILENT_KINDS = new Set<ErrorKind>(['auth', 'validation']);

const isReportable = (kind: ErrorKind): boolean => !SILENT_KINDS.has(kind);

export const formatAppError = (error: AppError): string =>
  `[${error.kind}${error.status ? ` ${error.status}` : ''}] ${error.message}`;

export const logError = (error: AppError, context?: Record<string, unknown>): void => {
  console.error(
    formatAppError(error),
    import.meta.dev ? { context, cause: error.cause } : { context },
  );

  if (!isReportable(error.kind)) return;

  reporter?.(error, context);
};
